import { useState, useCallback } from 'react';

const usePopup = () => {
  const [popupState, setPopupState] = useState({
    isOpen: false,
    type: null, // 'success' or 'error'
    title: '',
    message: '',
    timer: null,
  });

  const showPopup = useCallback((type, { title, message, timer = null }) => {
    setPopupState({
      isOpen: true,
      type,
      title,
      message,
      timer,
    });
  }, []);
  
  const showSuccessPopup = useCallback((props) => showPopup('success', props), [showPopup]);
  const showErrorPopup = useCallback((props) => showPopup('error', props), [showPopup]);

  const closePopup = useCallback(() => {
    setPopupState((prevState) => ({ ...prevState, isOpen: false }));
  }, []);

  return {
    popupState,
    showSuccessPopup,
    showErrorPopup,
    closePopup,
  };
};

export default usePopup;